/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import GenogramCustomConnectionsSyncManager
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramCustomConnectionsSyncManager";
import {isInstitutionNodeData} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramInstitutionHelper";
import {
	isStickyNoteNodeData,
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramStickyNoteHelper";

export function createGenogramAnalyticsSnapshot(genogramItem) {
	let nodes = genogramItem?.jsonData?.elements?.nodes || []
	let edges = genogramItem?.jsonData?.elements?.edges || []
	let personNodes = nodes.filter(node => isPersonNode(node?.data))
	let noteCount = countNodeNotes(nodes) + countEdgeNotes(edges)
	let customConnectionCount = countCustomConnectionEdges(edges)

	return {
		person_count: personNodes.length,
		relationship_count: edges.length,
		custom_connection_count: customConnectionCount,
		group_count: (genogramItem?.nodeGroups || []).length,
		notes_count: noteCount,
	}
}

export function createGenogramAnalyticsId(genogramItem, fallbackId = null) {
	let genogramId = genogramItem?.id
	if(!genogramId){
		genogramId = genogramItem?.clientId
	}
	if(!genogramId){
		genogramId = fallbackId
	}
	return genogramId || null
}

function isPersonNode(nodeData = {}) {
	let isPerson = !nodeData?.isAuxNode
	if(nodeData?.isHandwritingSpaceNote){
		isPerson = false
	}
	if(isStickyNoteNodeData(nodeData) || isInstitutionNodeData(nodeData)){
		isPerson = false
	}
	return isPerson
}

function countNodeNotes(nodes = []) {
	let noteCount = 0
	for(let node of nodes){
		if(hasNodeNote(node?.data)){
			noteCount++
		}
	}
	return noteCount
}

function hasNodeNote(nodeData = {}) {
	let noteText = nodeData?.note
	if(typeof noteText === "string" && noteText.trim()){
		return true
	}

	noteText = nodeData?.noteText
	return typeof noteText === "string" && noteText.trim().length > 0
}

function countEdgeNotes(edges = []) {
	let noteCount = 0
	for(let edge of edges){
		let noteText = edge?.data?.note
		if(typeof noteText === "string" && noteText.trim()){
			noteCount++
		}
	}
	return noteCount
}

function countCustomConnectionEdges(edges = []) {
	let customConnectionCount = 0
	for(let edge of edges){
		let lineSubType = edge?.data?.lineSubType || ""
		if(GenogramCustomConnectionsSyncManager.isCustomLineSubType(lineSubType)){
			customConnectionCount++
		}
	}
	return customConnectionCount
}
